export const TipoSensor = {
  1: 'Tensao',
  2: 'Pressao',
  3: 'Corrente',
  4: 'Nivel Reservatorio',
}

export const EpanetSensorTipo = {
  0: 'Node',
  // ['1']: 'Link',
  2: 'Reservatorio',
}

export const EquipamentoConfigTipo = {
  0: 'Final de rede',
  1: 'Moto-bomba',
}

export const TipoTermo = {
  Literal: 1,
  Funcao: 2,
  Sensor: 3,
  SensorVirtual: 4,
}

export const TipoTermoString = {
  [TipoTermo.Literal]: 'Valor',
  [TipoTermo.Sensor]: 'Sensor',
  [TipoTermo.SensorVirtual]: 'SensorVirtual',
}

export const Termos = {
  AVG: {
    text: 'AVG',
    tipo: TipoTermo.Funcao,
    identificador: 'AVG',
  },
  ComparaUltimosDados: {
    text: 'Compara Ultimos Dados',
    tipo: TipoTermo.Funcao,
    identificador: 'ComparaUltimosDados',
  },
  VerificaUltimoEnvio: {
    text: 'Verifica Ultimo envio',
    tipo: TipoTermo.Funcao,
    identificador: 'VerificaUltimoEnvio',
  },
  Sensor: {
    text: 'Sensor',
    tipo: TipoTermo.Sensor,
  },
  SensorVirtual: {
    text: 'Sensor Virtual',
    tipo: TipoTermo.SensorVirtual,
  },
  Valor: {
    text: 'Valor',
    tipo: TipoTermo.Literal,
  },
}

export const SkippedConfiguracaoGeralEquipamento = new Set([
  'ApnConfig',
  'OperadoraConfig',
])

export const ConfiguracaoGeralEquipamento = {
  ApnConfig: {
    titulo: 'APN',
    subtitulo: 'Configuração de APN',
  },
  OperadoraConfig: {
    titulo: 'Operadora',
    subtitulo: 'Configuração de Operadora',
  },
  IntervaloMotoBombaConfig: {
    titulo: 'Intervalo',
    subtitulo: 'Tempo entre os envios',
  },
  IntervaloFinalRedeConfig: {
    titulo: 'Intervalo',
    subtitulo: 'Tempo entre os envios',
  },
  MotoBombaConfig: {
    titulo: 'Enviar comandos AUTO',
    subtitulo: 'Configura comandos automáticos',
  },
  ExecutarComandosConfig: {
    titulo: 'Habiltar Comandos',
    subtitulo: 'Habilita comandos',
  },
  EnvioDadosConfig: {
    titulo: 'Tipo de envio',
    subtitulo: 'Configura o envio de dados',
  },
  ExecutarComandosAutomaticosConfig: {
    titulo: 'Comandos AUTO',
    subtitulo: 'Habilita comandos automáticos',
  },
  PulsoConfig: {
    titulo: 'Pulso',
    subtitulo: 'Configura o pulso',
  },
  RadioFrequenciaConfig: {
    titulo: 'Radio Frequencia',
    subtitulo: 'Habilita a radio frequencia',
  },
  RadioFrequenciaEfrrfConfig: {
    titulo: 'Radio Frequencia EFRRF',
    subtitulo: 'Habilita a EFRRF',
  },
  CidadeConfig: {
    titulo: 'Cidade',
    subtitulo: 'Configura a cidade',
  },
  PinagemReleBombasConfig: {
    titulo: 'Pinagem Rele Bombas',
    subtitulo: 'Configura a pinagem do rele das bombas',
  },
  MetadataConfig: {
    titulo: 'Metadata',
    subtitulo: 'Solicita metadados',
  },
}

export const AcaoTipo = {
  comandoBasico: 0,
  sms: 1,
}

export const AcaoStatusTipo = {
  Aguardando: 0,
  Executado: 1,
  Cancelado: 2,
  Enviado: 3,
  NaoEnviado: 4,
  Expirado: 5,
}

export const VirtualSensorPeriodoTipo = {
  None: 0,
  Turno: 1,
  UltimasHoras: 2,
  Mensal: 3,
}

export const TipoPinoSensor = {
  0: 'Analogico',
  1: 'Digital',
  2: 'Radio Frequencia',
  3: 'Ultrassonico',
  4: 'RS485',
  5: 'RS485ABB',
}
